import { LoaderDot, LoaderWrapper } from './ChatContent.styles';

export const Loader = () => {
  return (
    <LoaderWrapper aria-label="Generating response">
      <LoaderDot />
      <LoaderDot />
      <LoaderDot />
    </LoaderWrapper>
  );
};
